import styled from "styled-components"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../ui/tabs"
import { Button } from "../../../ui/button"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "../../../ui/dropdown-menu"
import { Input } from "../../../ui/input"
import SimpleTable from '../../components/SimpleTable'
import { useCheckout } from '../../controllers/CheckoutController'

const CheckIn = () => {

    const ClaimsDataSource = [
        {
            key: '1',
            title: 'Issue 1',
            notes: 'Details about issue 1',
            createdOn: '2023-06-01',
            updatedOn: '2023-06-02',
            resolution: 'Resolved',
        },
        {
            key: '2',
            title: 'Issue 2',
            notes: 'Details about issue 2',
            createdOn: '2023-06-03',
            updatedOn: '2023-06-04',
            resolution: 'Unresolved',
        },
    ];


    const ClaimsColumns = [
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
        },
        {
            title: 'Created on',
            dataIndex: 'createdOn',
            key: 'createdOn',
        },
        {
            title: 'Updated on',
            dataIndex: 'updatedOn',
            key: 'updatedOn',
        },
        {
            title: 'Resolution',
            dataIndex: 'resolution',
            key: 'resolution',
        },
    ];
    // const CheckOutColumns = [
    //     {
    //         title: '到期日',
    //         dataIndex: 'issue_date_due',
    //         key: 'issue_date_due',
    //     },
    //     {
    //         title: '書名',
    //         dataIndex: 'bib_title',
    //         key: 'bib_title',
    //     },
    //     {
    //         title: '種類',
    //         dataIndex: 'item_itype_description',
    //         key: 'item_itype_description',
    //     },
    //     {
    //         title: '原圖書館',
    //         dataIndex: 'item_location',
    //         key: 'item_location',
    //     },
    //     {
    //         title: '借出日期',
    //         dataIndex: 'item_onloan',
    //         key: 'item_onloan',
    //     },
    //     {
    //         title: '借出圖書館',
    //         dataIndex: 'item_location',
    //         key: 'item_location',
    //     },
    //     {
    //         title: '費用',
    //         dataIndex: 'fee',
    //         key: 'fee',
    //     },
    //     {
    //         title: '罰金',
    //         dataIndex: 'fine',
    //         key: 'fine',
    //     },
    //     {
    //         title: '總額',
    //         dataIndex: 'totalAmount',
    //         key: 'totalAmount',
    //     },
    //     {
    //         title: '再出借',
    //         dataIndex: 'renewal',
    //         key: 'renewal',
    //     },
    //     {
    //         title: '還書',
    //         dataIndex: 'returnBook',
    //         key: 'returnBook',
    //     },
    // ];

    const CheckOutColumns = [
        {
            title: '到期日',
            dataIndex: 'issue_date_due',
            key: 'issue_date_due',
        },
        {
            title: '書名',
            dataIndex: 'bib_title',
            key: 'bib_title',
        },
        {
            title: '種類',
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
        {
            title: '原圖書館',
            dataIndex: 'item_location',
            key: 'item_location',
        },
        {
            title: '借出日期',
            dataIndex: 'item_onloan',
            key: 'item_onloan',
        },
        {
            title: '借出圖書館',
            dataIndex: 'item_location',
            key: 'item_location',
        },
        {
            title: '費用',
            dataIndex: 'fee',
            key: 'fee',
        },
        {
            title: '罰金',
            dataIndex: 'fine',
            key: 'fine',
        },
        {
            title: '總額',
            dataIndex: 'totalAmount',
            key: 'totalAmount',
        },
        {
            title: '再出借',
            dataIndex: 'renewal',
            key: 'renewal',
        },
        {
            title: '還書',
            dataIndex: 'returnBook',
            key: 'returnBook',
        },
    ];

    const CheckOutDataSource1 = [
        {
            dueDate: '2024-06-30',
            bookName: 'JavaScript: The Good Parts',
            category: 'Programming',
            originalLibrary: 'Library A',
            borrowDate: '2024-06-10',
            borrowLibrary: 'Library B',
            fee: 10,
            fine: 2,
            totalAmount: 12,
            renewal: true,
            returnBook: '2024-06-25',
        },
        {
            dueDate: '2024-07-15',
            bookName: 'Introduction to Algorithms',
            category: 'Computer Science',
            originalLibrary: 'Library C',
            borrowDate: '2024-06-01',
            borrowLibrary: 'Library D',
            fee: 15,
            fine: 3,
            totalAmount: 18,
            renewal: false,
            returnBook: '2024-07-10',
        },
    ];
    const onBefore = (value)=>{
        console.log('onBefore',value)
    }
    const onFinish = (value)=>{
        console.log('onFinish',value)
    }

    const {
        CheckoutData,
        getCheckoutData,
        postCheckoutData,
    } = useCheckout({
        onBefore,
        onFinish
    })


    return (
        <MainContainer>
            <Title>還書</Title>
            <WhiteBox>
                <LanContainer>
                    <Input />
                    <Button>還書</Button>
                </LanContainer>
            </WhiteBox>
            <Title>歸還書籍</Title>
            <SimpleTable columns={CheckOutColumns} dataSource={CheckoutData} />

        </MainContainer>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const LanContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: row;
-webkit-box-align: start;
align-items: start;
gap: 0.5em;
flex-wrap: nowrap;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.1em;
font-weight: 600;
padding-bottom: 0.5em;
}
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

const WhiteBox = styled.div`
background-color: #fff;
padding: 1em;
width: -webkit-fill-available;
`
const GrayText = styled.span`
color: #929292;
`

const Title = styled.div`
text-align: left;
width: 90%;
font-size: 1.6em;
font-weight: 700;
}
`

export default CheckIn